import { renderDate, renderDateValue } from '../utility/addressTabGridHelper';
import { PARTY_KIND } from './partyKindLookupConstants';

export const PARTY_GRID_COLUMNS = [
  {
    field: 'Name',
    headerName: 'Name',
    width: 200,
    valueGetter: (params) =>
      params.row.PartyType === PARTY_KIND.PLACE ? params.row.PlaceName : params.row.PersonName,
  },
  {
    field: 'PartyID',
    headerName: 'Party ID',
    width: 130,
    valueGetter: (params) =>
      params.row.PartyType === PARTY_KIND.PLACE ? params.row.PlaceID : params.row.PersonID,
  },
  { field: 'PartyType', headerName: 'Party Type', width: 120 },
  { field: 'PriorityOrder', headerName: 'Priority Order', width: 140 },
  { field: 'Relationship', headerName: 'Relationship', width: 150 },
  { field: 'AdvisoryText', headerName: 'Advisory Text', width: 220 },
  { field: 'Created', headerName: 'Created', width: 180, valueFormatter: renderDate },
  { field: 'CreatedBy', headerName: 'Created By', width: 150 },
  { field: 'Updated', headerName: 'Updated', width: 180, valueFormatter: renderDate },
  { field: 'UpdatedBy', headerName: 'Updated By', width: 150 },
];

export const DETAIL_FIELDS = [
  { field: 'Name', label: 'Name' },
  { field: 'PartyID', label: 'Party ID' },
  { field: 'PartyType', label: 'Party Type' },
  { field: 'PriorityOrder', label: 'Priority Order' },
  { field: 'AdvisoryText', label: 'Advisory Text' },
  { field: 'RelationshipDescription', label: 'Relationship' },
  { field: 'CreatedBy', label: 'Created By' },
  { field: 'Updated', label: 'Updated', render: renderDateValue },
  { field: 'UpdatedBy', label: 'Updated By' },
];

export const WARRANT_FIELDS = [
  { field: 'WarrantID', label: 'Warrant ID' },
  { field: 'IssueAgencyID', label: 'Issuing Agency' },
  { field: 'IssuedDate', label: 'Issued Date', render: renderDateValue },
  { field: 'OffenseDescription', label: 'Offense' },
  { field: 'WarrantDisposition', label: 'Disposition' },
  { field: 'BondAmount', label: 'Bond Amount' },
  { field: 'Zone', label: 'Zone' },
];
